export const SET_API_ERROR = 'COMPLETED_FORM.SET_API_ERROR';
export const SUBMIT_PLAN = 'COMPLETED_FORM.SUBMIT_PLAN';
export const SET_SUBMIT_PLAN_ACTIVE = 'COMPLETED_FORM.SET_SUBMIT_PLAN_ACTIVE';
export const DISCARD_FORM = 'COMPLETED_FORM.DISCARD_FORM';
export const HAS_FORM_BEEN_MODIFIED = 'COMPLETED_FORM.HAS_FORM_BEEN_MODIFIED';
export const SET_REQ_QUEST = 'COMPLETED_FORM.SET_REQ_QUEST';
export const SHOW_REQ_SWITCH = 'COMPLETED_FORM.SHOW_REQ_SWITCH';
export const SHOW_READ_ONLY_FORM_SWITCH =
  'COMPLETED_FORM.SHOW_READ_ONLY_FORM_SWITCH';
export const SHOW_STICKIES = 'COMPLETED_FORM.SHOW_STICKIES';
export const SET_PARSING_FORM_ERROR = 'COMPLETED_FORM.SET_PARSING_FORM_ERROR';
export const SET_FAJITA_SELECTED = 'COMPLETED_FORM.SET_FAJITA_SELECTED';
export const SHOW_STICKIES_CONFIRM_DIALOG =
  'COMPLETED_FORM.SHOW_STICKIES_CONFIRM_DIALOG';
